export default __webpack_public_path__ + "static/media/IconBack.607d622d.svg";